import module from 'nominas/sumario/module.js'
import template from './template.html'
import './style.scss'

const catalogoEstatus = [
  {id: 'A', descripcion: 'Abierta', color: '#d5bc44'},
  {id: 'P', descripcion: 'Pendiente', color: '#dd6f3f'},
  {id: 'C', descripcion: 'Cerrada', color: '#74c245'},
]

const catalogoTipoNomina = [
  {id: 0, descripcion: 'Especial', tipo: 'E'},
  {id: 6, descripcion: 'Finiquito', tipo: 'F'},
  {id: 2, descripcion: 'Especial', tipo: 'E'},
  {id: 1, descripcion: 'Semanal', tipo: 'O'},
  {id: 3, descripcion: 'Quincenal', tipo: 'O'},
  {id: 4, descripcion: 'Mensual', tipo: 'O'},
  {id: 5, descripcion: 'Catorcenal', tipo: 'O'},
]

const maximoAvance = 8

const polarToCartesian = (centerX, centerY, radius, angleInDegrees) => {
  let angleInRadians = (angleInDegrees - 90) * Math.PI / 180.0

  return {
    x: +(centerX + (radius * Math.cos(angleInRadians))).toFixed(2),
    y: +(centerY + (radius * Math.sin(angleInRadians))).toFixed(2),
  };
}

function describeArc (x, y, radius, startAngle, endAngle) {
  let start = polarToCartesian(x, y, radius, endAngle)
  let end = polarToCartesian(x, y, radius, startAngle)
  let largeArcFlag = endAngle - startAngle <= 180 ? 0 : 1

  return `M ${start.x} ${start.y} A ${radius} ${radius} 0 ${largeArcFlag} 0 ${end.x} ${end.y}`
}

export class NominasSumarioListaItemEstatus {
  idTipoNomina
  estatus = 'A'
  avance = 0
  data

  constructor ($element) {
    this.$element = $element
  }

  $onInit () {
    this.data = catalogoTipoNomina.find((estatus) => this.idTipoNomina === estatus.id)

    this.$element.attr('title', `${this.data.descripcion}, ${Math.round((this.avance * 100) / maximoAvance)}% completado`)
    this.$element.attr('tipo', this.data.tipo)

    if (this.avance === maximoAvance) {
      this.$element.addClass('nominas-sumario-lista-item-estatus--completado')
    } else if (this.avance > 0) {
      let radius = 20
      let arcLength = 360 / maximoAvance

      let strokeWidth = 3
      let strokeRadius = radius - (strokeWidth / 2)
      let content = `<circle stroke-width="${strokeWidth}" cx="${radius}" cy="${radius}" r="${strokeRadius}"/>`

      if (this.avance > 0) {
        let strokeWidth = 6
        let strokeRadius = radius - (strokeWidth / 2)
        content += `<path stroke-width="${strokeWidth}" class="nominas-sumario-lista-item-estatus__path" d="${describeArc(radius, radius, strokeRadius, 0, arcLength * this.avance)}"/>`

        for (let i = 0; i < maximoAvance; i++) {
          let inicio = (i * arcLength) - 3
          let final = (i * arcLength) + 3
          content += `<path stroke-width="${strokeWidth}" class="nominas-sumario-lista-item-estatus__path" d="${describeArc(radius, radius, strokeRadius, inicio, final)}"/>`
        }
      }

      this.$element.append(`<svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40">${content}</svg>`)
    } else {
      this.$element.append(`<svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40"><circle stroke-width="2" cx="20" cy="20" r="19"/></svg>`)
    }
  }
}

module.component('nominasSumarioListaItemEstatus', {
  controller: NominasSumarioListaItemEstatus,
  template,
  bindings: {
    idTipoNomina: '<',
    estatus: '<',
    avance: '<',
  },
})



// WEBPACK FOOTER //
// ./src/nominas/sumario/components/lista/item/estatus/component.js